<script setup>
import { inject, ref, watch } from 'vue'

import CheckboxQuestionComponent from '@/components/CMB/Components/Questions/CheckboxQuestionComponent.vue'
import TextQuestionComponent from '@/components/CMB/Components/Questions/TextQuestionComponent.vue'
import DateQuestionComponent from '@/components/CMB/Components/Questions/DateQuestionComponent.vue'
import EmailQuestionComponent from '@/components/CMB/Components/Questions/EmailQuestionComponent.vue'
import RadioQuestionComponent from '@/components/CMB/Components/Questions/RadioQuestionComponent.vue'
import NumericQuestionComponent from '@/components/CMB/Components/Questions/NumericQuestionComponent.vue'
import SelectQuestionComponent from '@/components/CMB/Components/Questions/SelectQuestionComponent.vue'

const { handleAnswer, compiledPoll, question } = defineProps([
  'handleAnswer',
  'compiledPoll',
  'question',
  'last'
])
const questionsErrors = inject('questionsErrors')
const questionError = ref(null)

const checkErrors = () => {
  questionError.value = null
  for (const questionsError of questionsErrors.value) {
    if (
      questionsError['params']['dpa.question.reference'] &&
      questionsError['params']['dpa.question.reference'] === question.reference
    ) {
      if (
        questionsError['params']['dpa.error.customMessage'] &&
        questionsError['params']['dpa.error.customMessage'].trim() !== ''
      ) {
        questionError.value =
          questionsError['params']['dpa.error.customMessage']
      } else {
        questionError.value = questionsError['message']
      }
    }
  }
}

watch(
  questionsErrors,
  () => {
    checkErrors()
  },
  {
    deep: true
  }
)
</script>

<template>
  <div class="card question-component mt-1 border-0 shadow-none">
    <div :class="'card-body px-0 ' + (!last ? 'border-bottom' : '')">
      <p v-if="questionError" class="text-danger fw-bold">
        {{ questionError }}
      </p>

      <text-question-component
        :compiled-poll="compiledPoll"
        v-if="question.type === 'text'"
        :question="question"
        :handle-answer="handleAnswer"
      ></text-question-component>
      <date-question-component
        :compiled-poll="compiledPoll"
        v-else-if="question.type === 'date'"
        :question="question"
        :handle-answer="handleAnswer"
      ></date-question-component>
      <numeric-question-component
        :compiled-poll="compiledPoll"
        v-else-if="question.type === 'numeric'"
        :question="question"
        :handle-answer="handleAnswer"
      ></numeric-question-component>
      <email-question-component
        :compiled-poll="compiledPoll"
        v-else-if="question.type === 'email'"
        :question="question"
        :handle-answer="handleAnswer"
      ></email-question-component>
      <checkbox-question-component
        :compiled-poll="compiledPoll"
        v-else-if="question.type === 'checkbox'"
        :question="question"
        :handle-answer="handleAnswer"
      ></checkbox-question-component>
      <select-question-component
        :compiled-poll="compiledPoll"
        v-else-if="question.type === 'select'"
        :question="question"
        :handle-answer="handleAnswer"
      ></select-question-component>
      <radio-question-component
        :compiled-poll="compiledPoll"
        v-else-if="question.type === 'radio'"
        :question="question"
        :handle-answer="handleAnswer"
      ></radio-question-component>
    </div>
  </div>
</template>

<style scoped lang="scss"></style>
